<div class="wvTop" [ngClass]="hasBackdrop ? 'wvCustomItemDark' : 'wvCustomItemLight'">
    <div class="wvTopHeader">
        <div class="wvTopTitle txtOverflow" [ngClass]="'title' + moduleKey">{{topState?.TopTitle}} <span [hidden]="topState?.TopTitle == '' || topMetricName == ''">-</span> {{topMetricName}}</div>
    </div>

    <div class="wvTopPodiumArea" [ngClass]="'podium' + moduleKey">
        <!--2nd Place-->
        <div class="wvTopPodium topTwo" *ngIf="topData?.length > 0">
            <div class="wvTopImage" style="width:80%; height:65%"
                 [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + (topData[1].imgID || '-2') + '&w=500&h=500)', 'border': getPodiumColor(2) }" *ngIf="!topData[1].useAvatar"></div>
            <div class="wvTopImage" style="width:80%; height:65%; background-size:contain"
                 [ngStyle]="{ 'background-image': 'url(../Admin/AvatarProfileImage.aspx?loginid=' + topData[1].imgID + '&w=500&h=600)', 'border': getPodiumColor(2) }" *ngIf="topData[1].useAvatar"></div>
            <div class="wvTopPosition wvTopSecondPlace" [class]="getPodiumClass(2)"></div>

            <div class="wvTopData">
                <div class="wvTopAgentName txtOverflow" [ngClass]="'name' + moduleKey">{{topData[1].groupName}}</div>
                <div class="wvTopMetricValue" [ngClass]="'value' + moduleKey">{{topData[1].metricData.MetricDisplayValue != null ? topData[1].metricData.MetricDisplayValue : ""}}</div>
            </div>
        </div>

        <!--1st Place-->
        <div class="wvTopPodium mx-1" *ngIf="topData?.length > 0">
            <div class="wvTopImage" style="width:90%; height:68%; border:3px solid #E6B400"
                 [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + (topData[0].imgID || '-2') + '&w=500&h=500)' }" *ngIf="!topData[0].useAvatar"></div>
            <div class="wvTopImage" style="width:90%; height:68%; border:3px solid #E6B400; background-size:contain"
                 [ngStyle]="{ 'background-image': 'url(../Admin/AvatarProfileImage.aspx?loginid=' + topData[0].imgID + '&w=500&h=600)' }" *ngIf="topData[0].useAvatar"></div>
            <div class="wvTopPosition wvTopFirstPlace"></div>

            <div class="wvTopData">
                <div class="wvTopAgentName txtOverflow" [ngClass]="'name' + moduleKey">{{topData[0].groupName}}</div>
                <div class="wvTopMetricValue" [ngClass]="'value' + moduleKey">{{topData[0].metricData.MetricDisplayValue != null ? topData[0].metricData.MetricDisplayValue : ""}}</div>
            </div>
        </div>

        <!--3rd Place-->
        <div class="wvTopPodium topThree" *ngIf="topData?.length > 0">
            <div class="wvTopImage three" style="width:66%; height:61%"
                 [ngStyle]="{ 'background-image': 'url(../Admin/ImageResizer.aspx?imgid=' + (topData[2].imgID || '-2') + '&w=500&h=500)', 'border': getPodiumColor(3) }" *ngIf="!topData[2].useAvatar"></div>
            <div class="wvTopImage three" style="width:66%; height:61%; background-size:contain"
                 [ngStyle]="{ 'background-image': 'url(../Admin/AvatarProfileImage.aspx?loginid=' + topData[2].imgID + '&w=500&h=600)', 'border': getPodiumColor(3) }"*ngIf="topData[2].useAvatar"></div>
            <div class="wvTopPosition wvTopThirdPlace" [class]="getPodiumClass(3)"></div>

            <div class="wvTopData">
                <div class="wvTopAgentName txtOverflow" [ngClass]="'name' + moduleKey">{{topData[2].groupName}}</div>
                <div class="wvTopMetricValue" [ngClass]="'value' + moduleKey">{{topData[2].metricData.MetricDisplayValue != null ? topData[2].metricData.MetricDisplayValue : ""}}</div>
            </div>
        </div>
    </div>
</div>

<div class="wvCustomItem wvSlideError d-flex" *ngIf="slideError">
    <div class="sadErrorBox">
        <div class="errorCharacter"></div>

        <div class="errorText d-inline-block">
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Uh_Oh">Uh Oh</div>
            <div cvLocalizedText langSection="Wallboard_Display" langKey="Something_Went_Wrong">Something went wrong</div>
        </div>
    </div>
</div>
